import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import wranglerActions from '../../actions/wranglers';

import UserTable from './user-table';

class UserAdmin extends React.Component {
  componentDidMount() {
    this.props.fetchWranglers();
  }

  render() {
    return (
      <UserTable
        wranglers={this.props.wranglers}
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  ...wranglerActions,
}, dispatch);

const mapStateToProps = ({ wranglers }) => ({
  wranglers: wranglers.wranglers,
});

export default connect(mapStateToProps, mapDispatchToProps)(UserAdmin);
